<script lang="ts">
  import { Icon } from '@shared/ui/icon';
  import { convertDateToUserTimeZone } from '@shared/utils';

  import ChipWallet from './chip-wallet.svelte';
  import type { HashDataTemp } from '../types';

  export let owner: HashDataTemp | undefined; // TODO - change to HashData when history API is updated
  export let price: number | null;
  export let date: number | null | undefined = undefined; // ~TODO: EpochTimeStamp is not defined. Maybe some svelte bug @mingwe

  let dateStr: string | null = null;

  $: dateStr = date ? convertDateToUserTimeZone(date) : null;
</script>

<div class="text-center">
  <p class="mb-4 mt-2 text-xl font-medium">Digital Original has been sold to</p>
  <div class="mb-4 flex items-center justify-center gap-4">
    <ChipWallet walletId="{owner?.value}" href="{owner?.explorer_url}" target="{'_blank'}" />
  </div>

  <p class="mb-4 inline-flex items-end gap-1">
    {#if price}
      <span class="flex items-center gap-1 text-center text-3xl font-medium leading-[24px]">
        <Icon name="usdc" width="{24}" height="{24}" />

        {price}
      </span>

      <span class="text-base leading-none">USDC</span>
    {/if}
  </p>

  {#if dateStr}
    <p class="mb-4 text-xs uppercase">{dateStr}</p>
  {/if}
</div>
